import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import '../../css/theme/bootstrap.css';
import '../../css/theme/custom.css';
import '../../css/bootstrap-float-label.min.css';
import MainMenu from '../../Components/Common/MainMenu';
import Header from '../../Components/Shared/Header';
import NavigationBar from '../../Components/Shared/NavigationBar';
import Main from './Main';
import Footer from '../../Components/Shared/Footer';
import {
  GetLoggedInUserApi,
  GetCartApi,
  LogoutUserApi,
  ShowFreeHolidayShipping
} from '../../Code/Data';

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = { currentUser: null, shoppingCart: null, userLogout: null, isLoading: true };
  }

  async componentWillMount() {
    let currentUser = null, shoppingCart = null;
    const userApi = await GetLoggedInUserApi(),
      shoppingCartApi = await GetCartApi(),
      showFreeHolidayShipping = await ShowFreeHolidayShipping(),
      refreshShoppingCart = async () => {
        let shoppingCartApi = await GetCartApi();
        if (shoppingCartApi.Succeeded) {
          let shoppingCart = shoppingCartApi.ShoppingCart;
          this.setState({ shoppingCart });
        }
      },
      userLogout = async () => {
        const logoutApi = await LogoutUserApi();
        if (logoutApi.Succeeded) {
          let shoppingCart = null;
          const cartApi = await GetCartApi();
          if (cartApi.Succeeded) {
            shoppingCart = cartApi.ShoppingCart;
          }
          this.setState({ currentUser: null, shoppingCart });
        }
      };
    if (userApi.Succeeded) {
      currentUser = userApi.User;
    }
    if (shoppingCartApi.Succeeded) {
      shoppingCart = shoppingCartApi.ShoppingCart;
    }

    this.setState({ currentUser, shoppingCart, userLogout, refreshShoppingCart, isLoading: false, showFreeHolidayShipping });
  }

  render() {
    return (
      <div className="App">
        <Helmet>
          <meta name="keywords" content="valentines day charity,mothers day,super bowl party favors,holiday donation gift, giving back, gifts for giving back,holiday charity gift,911 day donations,last minute christmas gifts,best last minute holiday gift,mothers day donation. super bowl charity,earth day charities,earth day donations,gift cards,graduation gift,valentines day,earth day charity,new years best wishes,teachers gift,earth day 2011,new years cards,new years charity,christmas gifts,support our troops,christmas present,graduation gifts,valentines day gift,business gift,meaningful gift,wedding gifts,facebook, party favors,facebook charity card,business gifts,gift Ideas,corporate gift;birthday gifts, bridal favors,bridal registry,Mothers day charity gifts, holiday gifts,fathers day gifts,christmas gifts,donation gift,donation gifts,thoughtful gift" />
          <meta name="description" content="The pioneer and leading Charity Gift, offering 'giving back' for over 2000 charities. Official donation site of the Red Cross. Upload CSV file of recipients, robust corporate branding suite." />
          <meta name="robots" content="index, follow" />
          <title>Charity|Choice Donation Gift Cards:Birthday Donation Gift, Branded Corporate Business Gift Ideas</title>
        </Helmet>
        <Header {...this.state} />
        <div className="d-none d-md-block">
          <NavigationBar {...this.state} />
        </div>
        <div className="d-md-none">
          <MainMenu block {...this.state} />
        </div>
        <Main {...this.state} />
        <Footer {...this.state} />
      </div>
    );
  }
}
